import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import request from "../../api/request";
import { toast } from "react-toastify";

// New async thunk action to handle image upload
export const uploadImage = createAsyncThunk(
  "main/uploadImage",
  async (imageData, { getState }) => {
    try {
      const token = getState().main.user?.token;
      const formData = new FormData();
      formData.append("image", imageData);

      // Make the request with the FormData object
      const response = await request.post(
        `/api/hakim/upload/mainImage/${token}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Assuming the backend responds with the URL of the uploaded image
      return response.data.image;
    } catch (error) {
      console.error("Error uploading image:", error);
      throw error;
    }
  }
);
export const uploadDoctorImage = createAsyncThunk(
  "main/uploadDoctorImage",
  async (imageData, { getState }) => {
    try {
      const token = getState().main.user?.token;
      const formData = new FormData();
      formData.append("image", imageData);

      // Make the request with the FormData object
      const response = await request.post(
        `/api/hakim/upload/mainDoctorImage/${token}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Assuming the backend responds with the URL of the uploaded image
      return response.data.image;
    } catch (error) {
      console.error("Error uploading image:", error);
      throw error;
    }
  }
);
export const upload1Image = createAsyncThunk(
  "main/upload1Image",
  async (imageData, { getState }) => {
    try {
      const token = getState().main.user?.token;
      const formData = new FormData();
      formData.append("image", imageData);

      // Make the request with the FormData object
      const response = await request.post(
        `/api/hakim/upload/clinic1Image/${token}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Assuming the backend responds with the URL of the uploaded image
      return response.data.image;
    } catch (error) {
      console.error("Error uploading image:", error);
      throw error;
    }
  }
);
export const upload2Image = createAsyncThunk(
  "main/upload2Image",
  async (imageData, { getState }) => {
    try {
      // Create a new FormData object
      const formData = new FormData();
      formData.append("image", imageData);
      const token = getState().main.user?.token;

      // Make the request with the FormData object
      const response = await request.post(
        `/api/hakim/upload/clinic2Image/${token}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Assuming the backend responds with the URL of the uploaded image
      return response.data.image;
    } catch (error) {
      console.error("Error uploading image:", error);
      throw error;
    }
  }
);

export const AddNewCertificate = createAsyncThunk(
  "main/AddNewCertificate",
  async ({ details, photoFile }, { getState, dispatch }) => {
    try {
      // Create a new FormData object

      const formData = new FormData();
      formData.append("details", details);
      formData.append("image", photoFile);
      const token = getState().main.user?.token;

      // Make the request with the FormData object
      const response = await request.post(
        `/api/hakim/add/certificate/${token}/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Assuming the backend responds with the URL of the uploaded image
      toast.success("تم اضافه الشهاده بنجاح");
      await dispatch(fetchAllData());

      return response.data;
    } catch (error) {
      toast.error("حدث خطا ما");

      console.error("Error uploading image:", error);
      throw error;
    }
  }
);
export const AddNewDirection = createAsyncThunk(
  "main/AddNewDirection",
  async (
    { name, directions, photoFile, photoFile2 },
    { getState, dispatch }
  ) => {
    try {
      // Create a new FormData object

      const formData = new FormData();
      formData.append("name", name);
      formData.append("directions", directions);
      formData.append("image", photoFile);
      formData.append("image2", photoFile2);
      const token = getState().main.user?.token;

      // Make the request with the FormData object
      const response = await request.post(
        `/api/hakim/add/direction/${token}/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Assuming the backend responds with the URL of the uploaded image
      toast.success("تم اضافه التعليمات بنجاح");
      await dispatch(fetchAllData());

      return response.data;
    } catch (error) {
      toast.error("حدث خطا ما");

      console.error("Error uploading image:", error);
      throw error;
    }
  }
);
export const AddNewService = createAsyncThunk(
  "main/AddNewService",
  async (data, { getState, dispatch }) => {
    try {
      // Create a new FormData object

      const token = getState().main.user?.token;

      // Make the request with the FormData object
      const response = await request.post(
        `/api/hakim/add/service/${token}/`,
        data
      );

      // Assuming the backend responds with the URL of the uploaded image
      toast.success("تم اضافه الخدمه بنجاح");
      await dispatch(fetchAllData());

      return response.data;
    } catch (error) {
      toast.error("حدث خطا ما");

      console.error("Error uploading image:", error);
      throw error;
    }
  }
);
export const AddServiceImageAdd = createAsyncThunk(
  "main/AddServiceImageAdd",
  async ({ details, photoFile, id }, { getState, dispatch }) => {
    try {
      // Create a new FormData object

      const formData = new FormData();
      formData.append("details", details);
      formData.append("id", id);
      formData.append("image", photoFile);
      const token = getState().main.user?.token;

      // Make the request with the FormData object
      const response = await request.post(
        `/api/hakim/add/service-image/${token}/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Assuming the backend responds with the URL of the uploaded image
      toast.success("تم اضافه الصوره بنجاح");
      await dispatch(fetchAllData());

      return response.data;
    } catch (error) {
      toast.error("حدث خطا ما");

      console.error("Error uploading image:", error);
      throw error;
    }
  }
);
export const AddImageInfo = createAsyncThunk(
  "main/AddImageInfo",
  async ({ name, photoFile }, { getState, dispatch }) => {
    try {
      // Create a new FormData object

      const formData = new FormData();
      formData.append("name", name);
      formData.append("image", photoFile);
      const token = getState().main.user?.token;

      // Make the request with the FormData object
      const response = await request.post(
        `/api/hakim/add/case-images/${token}/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Assuming the backend responds with the URL of the uploaded image
      toast.success("تم اضافه الصوره بنجاح");
      await dispatch(fetchAllData());

      return response.data;
    } catch (error) {
      toast.error("حدث خطا ما");

      console.error("Error uploading image:", error);
      throw error;
    }
  }
);
export const AddVideoInfo = createAsyncThunk(
  "main/AddVideoInfo",
  async ({ name, videoFile }, { getState, dispatch }) => {
    try {
      // Create a new FormData object

      const formData = new FormData();
      formData.append("name", name);
      formData.append("video", videoFile);
      const token = getState().main.user?.token;

      // Make the request with the FormData object
      const response = await request.post(
        `/api/hakim/add/case-videos/${token}/`,
        formData
      );

      // Assuming the backend responds with the URL of the uploaded image
      toast.success("تم اضافه الفيديو بنجاح");
      await dispatch(fetchAllData());

      return response.data;
    } catch (error) {
      toast.error("حدث خطا ما");

      console.error("Error uploading image:", error);
      throw error;
    }
  }
);

export const EditServiceImageD = createAsyncThunk(
  "main/EditServiceImageD",
  async ({ details, photoFile, id }, { getState, dispatch }) => {
    try {
      // Create a new FormData object

      const formData = new FormData();
      formData.append("details", details);
      formData.append("id", id);
      formData.append("image", photoFile);
      const token = getState().main.user?.token;

      // Make the request with the FormData object
      const response = await request.post(
        `/api/hakim/edit/service-image/${token}/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Assuming the backend responds with the URL of the uploaded image
      toast.success("تم اضافه الصوره بنجاح");
      await dispatch(fetchAllData());

      return response.data;
    } catch (error) {
      toast.error("حدث خطا ما");

      console.error("Error uploading image:", error);
      throw error;
    }
  }
);
export const EditServiceD = createAsyncThunk(
  "main/EditServiceD",
  async (data, { getState, dispatch }) => {
    try {
      // Create a new FormData object

      const token = getState().main.user?.token;
      console.log(data);
      // Make the request with the FormData object
      const response = await request.post(
        `/api/hakim/edit/service/${token}/`,
        data
      );

      // Assuming the backend responds with the URL of the uploaded image
      toast.success("تم تعديل الخدمه بنجاح");
      await dispatch(fetchAllData());
      return response.data;
    } catch (error) {
      toast.error("حدث خطا ما");

      console.error("Error uploading image:", error);
      throw error;
    }
  }
);
export const EditDirectionD = createAsyncThunk(
  "main/AddNewDirection",
  async (
    { name, directions, photoFile, photoFile2, directionId },
    { getState, dispatch }
  ) => {
    try {
      // Create a new FormData object

      const formData = new FormData();
      formData.append("name", name);
      formData.append("directions", directions);
      formData.append("image", photoFile);
      formData.append("image2", photoFile2);
      formData.append("id", directionId);
      const token = getState().main.user?.token;

      // Make the request with the FormData object
      const response = await request.post(
        `/api/hakim/edit/direction/${token}/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Assuming the backend responds with the URL of the uploaded image
      toast.success("تم تعديل التعليمات بنجاح");
      await dispatch(fetchAllData());

      return response.data;
    } catch (error) {
      toast.error("حدث خطا ما");

      console.error("Error uploading image:", error);
      throw error;
    }
  }
);
export const saveAboutClinic = createAsyncThunk(
  "main/saveAboutClinic",
  async (data, { getState }) => {
    try {
      const token = getState().main.user?.token;

      // Make the request with the FormData object
      const response = await request.post(
        `/api/hakim/edit/aboutClinic/${token}`,
        data
      );

      // Assuming the backend responds with the URL of the uploaded image
      return response.data;
    } catch (error) {
      console.error("Error uploading image:", error);
      throw error;
    }
  }
);

export const delImageInfo = createAsyncThunk(
  "main/delImageInfo",
  async (id, { getState, dispatch }) => {
    try {
      const token = getState().main.user?.token;
      toast.info("Deleting Image...", { autoClose: false });
      // Make the request with the FormData object
      const response = await request.delete(
        `/api/hakim/del/case-image/${id}/${token}`
      );

      await dispatch(fetchAllData());

      toast.success("Done Delete Image.", { autoClose: false });
      return response.data;
    } catch (error) {
      console.error("Error uploading image:", error);
      throw error;
    }
  }
);
export const delVideoInfo = createAsyncThunk(
  "main/delVideoInfo",
  async (id, { getState, dispatch }) => {
    try {
      const token = getState().main.user?.token;
      toast.info("Deleting Video...", { autoClose: false });
      // Make the request with the FormData object
      const response = await request.delete(
        `/api/hakim/del/case-video/${id}/${token}`
      );

      await dispatch(fetchAllData());

      toast.success("Done Delete Video.", { autoClose: false });
      return response.data;
    } catch (error) {
      console.error("Error uploading image:", error);
      throw error;
    }
  }
);
export const delCertificateInfo = createAsyncThunk(
  "main/delCertificateInfo",
  async (id, { getState, dispatch }) => {
    try {
      const token = getState().main.user?.token;
      toast.info("Deleting Certificate...", { autoClose: false });
      // Make the request with the FormData object
      const response = await request.delete(
        `/api/hakim/del/certificate/${id}/${token}`
      );

      await dispatch(fetchAllData());

      toast.success("Done Delete Certificate.", { autoClose: false });
      return response.data;
    } catch (error) {
      console.error("Error uploading image:", error);
      throw error;
    }
  }
);
export const delServiceInfo = createAsyncThunk(
  "main/delServiceInfo",
  async (id, { getState, dispatch }) => {
    try {
      const token = getState().main.user?.token;
      toast.info("Deleting Service...", { autoClose: false });
      // Make the request with the FormData object
      const response = await request.delete(
        `/api/hakim/del/service/${id}/${token}`
      );

      await dispatch(fetchAllData());

      toast.success("Done Delete Service.", { autoClose: false });
      return response.data;
    } catch (error) {
      console.error("Error uploading image:", error);
      throw error;
    }
  }
);
export const delServiceImageInfo = createAsyncThunk(
  "main/delServiceImageInfo",
  async (id, { getState, dispatch }) => {
    try {
      const token = getState().main.user?.token;
      toast.info("Deleting Service...", { autoClose: false });
      // Make the request with the FormData object
      const response = await request.delete(
        `/api/hakim/del/service-image/${id}/${token}`
      );

      await dispatch(fetchAllData());

      toast.success("Done Delete Service Image.", { autoClose: false });
      return response.data;
    } catch (error) {
      console.error("Error uploading image:", error);
      throw error;
    }
  }
);

export const fetchAllData = createAsyncThunk("main/fetchAllData", async () => {
  const response = await request.get("/api/hakim/");
  // Serialize the necessary data from headers
  const serializedHeaders = {
    "content-length": response.headers["content-length"],
    "content-type": response.headers["content-type"],
  };
  // Return the serialized response
  return { data: response.data, headers: serializedHeaders };
});
export const mainSlice = createSlice({
  name: "main",
  initialState: {
    isAuthenticated: false,
    user: null,
    data: {},
    headers: {},
    error: null,
  },
  reducers: {
    loginSuccess: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload;
      state.error = null;
    },
    loginFailure: (state, action) => {
      state.isAuthenticated = false;
      state.user = null;
      state.error = action.payload;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllData.pending, (state) => {
        state.error = null;
      })
      .addCase(fetchAllData.fulfilled, (state, action) => {
        state.data = action?.payload?.data?.data;
        state.headers = action.payload.headers; // Set headers in state
      })
      .addCase(fetchAllData.rejected, (state, action) => {
        state.error = action.error.message;
      });
  },
});

// Action creator for login
export const { loginSuccess, loginFailure, logout } = mainSlice.actions;

// Action creator for login
export const login = (credentials) => async (dispatch) => {
  toast.info("جاري تسجيل الدخول");
  try {
    const response = await request.post("/api/hakim/login", credentials);
    dispatch(loginSuccess(response.data));
    toast.success("تم تسجيل الدخول بنجاح");
  } catch (error) {
    toast.error("كلمه المرور او اسم المستخدم خطا");
    dispatch(loginFailure(error.message));
  }
};

export default mainSlice.reducer;
